/* eslint-disable import/no-named-as-default */
import compose from 'ramda/src/compose';
import { withFormConnected } from 'components/styleguide/HOC';
import DRAWERS from '../constants';

export default compose((c) => withFormConnected(c, { formId: DRAWERS.CLEARANCE_FULL_LIST }));
